import {
	itemsObject,
	getDOMElements
} from '../common/utilities.js';

// Import utilities
const {
	isDefined,
	isEmpty,
	getURLParameter
} = _uo.utility;

import ItemCreatorIntegrations  from './integrations-grid.js';

import MetaboxItems             from '../metabox/items.js';
import MetaboxFooter            from '../metabox/footer.js';

class Triggers {
	constructor(){
		// Create console group
		// console.group( 'Triggers' );

		// Get and clear metabox
		let metabox = getDOMElements( 'metabox', { type: 'trigger' } ).get(0);
		metabox.innerHTML = '';

		// Get recipe triggers
		let triggers = itemsObject( 'get', {
			filter: { itemType: 'trigger' },
			format: 'array',
		});

		// Insert the and/or selector
		metabox.insertAdjacentHTML( 'afterBegin', `<ua-builder-triggers-and-or-selector></ua-builder-triggers-and-or-selector>` );

		// Check if it has triggers
		if ( ! isEmpty( triggers ) ){
			// Render items
			new MetaboxItems( 'trigger', triggers, false );

			// Create metabox footer
			new MetaboxFooter( 'trigger' );

			// Check if we have to show the integrations on load
			if ( this.isContinuingIntegrationConnection() ){
				// Render the integrations list
				new ItemCreatorIntegrations( 'trigger' );
			}
		}
		else {
			new ItemCreatorIntegrations( 'trigger' );

			// Create metabox footer
			new MetaboxFooter( 'trigger' );
		}

		// Close console group
		// console.groupEnd();
	}

	isContinuingIntegrationConnection(){
		return getURLParameter( null, 'ua_connecting_integration' ) == 1 && getURLParameter( null, 'ua_connecting_integration_context' ) == 'trigger';
	}
}

export default Triggers;